import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { WorkstationTermsStatus } from '@localagent/sdk';
import { getSDK } from '../services/sdk-instance';

const queryKey = (accountId: string) => ['account', accountId, 'workstation-terms'] as const;

export function useWorkstationTerms(accountId: string) {
  return useQuery<WorkstationTermsStatus, Error>({
    queryKey: queryKey(accountId),
    queryFn: () => getSDK().account.getWorkstationTerms(accountId),
    enabled: accountId !== '',
  });
}

export function useAcceptWorkstationTerms(accountId: string) {
  const queryClient = useQueryClient();
  return useMutation<WorkstationTermsStatus, Error, { version: string; sha256: string }>({
    mutationFn: (params) => getSDK().account.acceptWorkstationTerms(accountId, params),
    onSuccess: (status) => queryClient.setQueryData(queryKey(accountId), status),
  });
}
